import { ReactComponent as IconMistake } from "assets/icons/Mistake.svg";
import { ReactComponent as InformationHeader } from "assets/icons/InformationHeader.svg";

const ICON_DICTIONARY = {
  error: <IconMistake />,
  info: <InformationHeader />,
};

/**
 * @param {'error' | 'info'} [type]
 *
 * @return {JSX}
 * */
export default function getIcon(type) {
  return ICON_DICTIONARY[type] ?? ICON_DICTIONARY.error;
}
